import { mdlStatus } from "./CompAttachmentsMdl";
import { mdlGetPayfortFieldsReq } from "./mdlGetPayfortFieldsReq";

// export class mdlAddExtRedPolicyTravelRes{
//     public st!: mdlStatus;
//     public PaymentObj!: mdlGetPayfortFieldsReq;
   
// }

export class mdlAddExtRedPolicyTravelRes {
    public st: mdlStatus = new mdlStatus(); // or null if appropriate
    public PaymentObj: mdlGetPayfortFieldsReq = new mdlGetPayfortFieldsReq();
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlAddExtRedPolicyTravelRes.ts